module.exports = __webpack_public_path__ + "static/media/img_fenlei19.7da2a342.png";